import React from 'react';
import { ProfileHero } from './components/ProfileHero';
import { MatchContext } from './components/MatchContext';
import { IntentLinks } from './components/IntentLinks';
import { AgentCapabilities } from './components/AgentCapabilities';
import { PerformanceMetrics } from './components/PerformanceMetrics';
import { MarketsServed } from './components/MarketsServed';
import { ActiveListings } from './components/ActiveListings';
import { SellerReviews } from './components/SellerReviews';
export function App() {
  // Set to true when seller arrives from a match introduction
  const isMatchIntro = true;
  return <div className="min-h-screen bg-brand-offwhite font-sans text-brand-dark selection:bg-brand-forest selection:text-white" data-id="element-0">
      <main data-id="element-1">
        <ProfileHero data-id="element-2" />
        <MatchContext visible={isMatchIntro} data-id="element-3" />
        <IntentLinks data-id="element-4" />
        <PerformanceMetrics data-id="element-5" />
        <SellerReviews data-id="element-6" />
        <MarketsServed data-id="element-7" />
        <AgentCapabilities data-id="element-8" />
        <ActiveListings data-id="element-9" />
      </main>

      <footer className="bg-brand-dark text-gray-400 py-10 text-center" data-id="element-10">
        <div className="max-w-6xl mx-auto px-6 space-y-3" data-id="element-11">
          <div className="flex items-center justify-center gap-2 mb-4" data-id="element-12">
            <img src="https://cdn.magicpatterns.com/uploads/tg3VtfRMGFLgjFkX7oevaV/eaves_favicon_transparent.png" alt="Eaves" className="h-5 w-5" data-id="element-13" />
            <span className="text-sm text-gray-300 font-serif font-medium" data-id="element-14">
              Eaves Pro
            </span>
          </div>
          <div className="flex flex-wrap justify-center gap-4 text-sm mb-4" data-id="element-15">
            <a href="mailto:marcus@chengroup.com" className="hover:text-white transition-colors" data-id="element-16">
              marcus@chengroup.com
            </a>
            <span className="text-gray-600" data-id="element-17">·</span>
            <a href="tel:+14155550198" className="hover:text-white transition-colors font-mono" data-id="element-18">
              (415) 555-0198
            </a>
          </div>
          <p className="text-xs text-gray-500" data-id="element-19">
            Compass is a real estate broker licensed by the State of California.
            DRE #02145678. Performance data sourced from public records and
            verified platforms.
          </p>
          <p className="text-xs text-gray-600" data-id="element-20">
            © {new Date().getFullYear()} Eaves Technologies LLC · witheaves.com
          </p>
        </div>
      </footer>
    </div>;
}